import React, { useState, useEffect } from 'react';
import type { CompanyInfo } from '../types';

interface CompanyInfoCardProps {
  companyInfo: CompanyInfo;
  isEditing: boolean;
  onEdit: () => void;
  onSave: (data: CompanyInfo) => Promise<void>;
  onCancel: () => void;
  loading: boolean;
}

const CompanyInfoCard: React.FC<CompanyInfoCardProps> = ({
  companyInfo,
  isEditing,
  onEdit,
  onSave,
  onCancel,
  loading,
}) => {
  const [formData, setFormData] = useState<CompanyInfo>({
    companyName: companyInfo.companyName || '',
    companyWebsite: companyInfo.companyWebsite || '',
  });

  useEffect(() => {
    setFormData({
      companyName: companyInfo.companyName || '',
      companyWebsite: companyInfo.companyWebsite || '',
    });
  }, [companyInfo]);

  const handleSave = async () => {
    await onSave(formData);
  };

  return (
    <div className="bg-white rounded-2xl p-6 border border-[#EDEDED]">
      <div className="flex justify-between items-start mb-6">
        <div>
          <h2
            style={{
              fontFamily: 'Manrope',
              fontWeight: 600,
              fontSize: '20px',
              lineHeight: '27px',
              color: '#0B111E',
            }}
          >
            Company Information
          </h2>
          <p
            style={{
              fontFamily: 'Manrope',
              fontWeight: 400,
              fontSize: '14px',
              lineHeight: '19px',
              color: '#757575',
              marginTop: '4px',
            }}
          >
            Update your company details
          </p>
        </div>
        {!isEditing && (
          <button
            onClick={onEdit}
            className="px-4 py-2 text-[#015FA6] hover:bg-blue-50 rounded-lg transition-colors"
            style={{ fontFamily: 'Manrope', fontWeight: 500, fontSize: '14px' }}
          >
            Edit
          </button>
        )}
      </div>

      {isEditing ? (
        <div className="space-y-4">
          <div>
            <label
              style={{
                fontFamily: 'Manrope',
                fontWeight: 500,
                fontSize: '14px',
                color: '#0B111E',
              }}
            >
              Company Name
            </label>
            <input
              type="text"
              value={formData.companyName}
              onChange={(e) => setFormData({ ...formData, companyName: e.target.value })}
              className="w-full mt-2 px-4 py-3 border border-[#EDEDED] rounded-lg focus:outline-none focus:border-[#015FA6]"
              style={{ fontFamily: 'Manrope', fontSize: '16px' }}
            />
          </div>
          <div>
            <label
              style={{
                fontFamily: 'Manrope',
                fontWeight: 500,
                fontSize: '14px',
                color: '#0B111E',
              }}
            >
              Company Website
            </label>
            <input
              type="url"
              value={formData.companyWebsite || ''}
              onChange={(e) => setFormData({ ...formData, companyWebsite: e.target.value })}
              className="w-full mt-2 px-4 py-3 border border-[#EDEDED] rounded-lg focus:outline-none focus:border-[#015FA6]"
              style={{ fontFamily: 'Manrope', fontSize: '16px' }}
              placeholder="https://example.com"
            />
          </div>
          <div className="flex gap-3 pt-2">
            <button
              onClick={handleSave}
              disabled={loading}
              className="px-6 py-2 bg-[#015FA6] text-white rounded-lg hover:bg-[#014a82] transition-colors disabled:opacity-50"
              style={{ fontFamily: 'Manrope', fontWeight: 500, fontSize: '14px' }}
            >
              {loading ? 'Saving...' : 'Save'}
            </button>
            <button
              onClick={onCancel}
              className="px-6 py-2 border border-[#EDEDED] rounded-lg hover:bg-gray-50 transition-colors"
              style={{ fontFamily: 'Manrope', fontWeight: 500, fontSize: '14px', color: '#515151' }}
            >
              Cancel
            </button>
          </div>
        </div>
      ) : (
        <div className="space-y-4">
          <div>
            <p style={{ fontFamily: 'Manrope', fontSize: '14px', color: '#757575' }}>Company Name</p>
            <p style={{ fontFamily: 'Manrope', fontSize: '16px', color: '#0B111E', marginTop: '4px' }}>
              {companyInfo.companyName || '-'}
            </p>
          </div>
          <div>
            <p style={{ fontFamily: 'Manrope', fontSize: '14px', color: '#757575' }}>Company Website</p>
            <p style={{ fontFamily: 'Manrope', fontSize: '16px', color: '#0B111E', marginTop: '4px' }}>
              {companyInfo.companyWebsite || '-'}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompanyInfoCard;
